/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { AuthConsumer } from "../../AuthContext";
import PlugLanding from "../PlugLanding/PlugLanding";
import copyCn from "../PlugLanding/copyCn";

/**
 * The Plug marketing site in Simplified Chinese. All markup lives in
 * PlugLanding; this only picks the language.
 */
class PlugCn extends Component {
  render() {
    return (
      <AuthConsumer>
        {({ i18n }) => <PlugLanding {...this.props} copy={copyCn} lang="cn" i18n={i18n} />}
      </AuthConsumer>
    );
  }
}

export default PlugCn;
